import React from "react";
import HotelTwoToneIcon from "@material-ui/icons/HotelTwoTone";
import BathtubTwoToneIcon from "@material-ui/icons/BathtubTwoTone";
import DirectionsCarTwoToneIcon from "@material-ui/icons/DirectionsCarTwoTone";
import ElevatorIcon from "@material-ui/icons/SwapVert";
import SelectAllTwoToneIcon from "@material-ui/icons/SelectAllTwoTone";
import { TITLE_CARD_DEFAULTS } from "./TitleCardCustom.constants";

export const hasCityValue = (city) => {
  if (typeof city === "string") {
    return city.trim().length > 0;
  }
  return !!city;
};

export const normalizeText = (value) => {
  if (typeof value !== "string") return "";
  return value.trim();
};

export const formatCurrency = (
  value,
  currencyLabel = TITLE_CARD_DEFAULTS.currency
) => {
  if (!value && value !== 0) return "";
  const formattedValue = new Intl.NumberFormat("es-MX", {
    maximumFractionDigits: 0,
  }).format(value);
  return `$${formattedValue} ${currencyLabel}`;
};

export const propertyItems = (props) => [
  {
    value: props.rooms,
    label: props.rooms !== 1
      ? props.TranslateRoomPlural || TITLE_CARD_DEFAULTS.roomPlural
      : props.TranslateRoomSingular || TITLE_CARD_DEFAULTS.roomSingular,
    icon: <HotelTwoToneIcon className="icon" />,
    isVisible: !!props.rooms,
  },
  {
    value: props.bathrooms,
    label:
      props.bathrooms !== 1
        ? TITLE_CARD_DEFAULTS.bathroomPlural
        : TITLE_CARD_DEFAULTS.bathroomSingular,
    icon: <BathtubTwoToneIcon className="icon" />,
    isVisible: !!props.bathrooms,
  },
  {
    value: props.parking,
    label: props.parking !== 1
      ? props.TranslateParkingPlural || TITLE_CARD_DEFAULTS.parkingPlural
      : props.TranslateParkingSingular || TITLE_CARD_DEFAULTS.parkingSingular,
    icon: <DirectionsCarTwoToneIcon className="icon" />,
    isVisible: props.parking != null,
  },
  {
    value: props.area,
    label: TITLE_CARD_DEFAULTS.areaUnit,
    icon: <SelectAllTwoToneIcon className="icon" />,
    isVisible: !!props.area,
    isArea: true,
  },
  {
    value: props.elevators,
    label: props.elevators !== 1
      ? props.TranslateElevatorPlural || TITLE_CARD_DEFAULTS.elevatorPlural
      : props.TranslateElevatorSingular || TITLE_CARD_DEFAULTS.elevatorSingular,
    icon: <ElevatorIcon className="icon" />,
    isVisible: props.elevators != null,
  },
];
